import type { HandoverDisputeCreateResponseApi } from 'api-typings/contests/contests';
import type { ContestHandoverDispute } from './contest-handover-disputes.model';

export interface HandoverDisputeCreateDocument {
  readonly handoverId: number;
  readonly description: string;
}

export function transformHandoverDisputeCreate(
  result: HandoverDisputeCreateResponseApi,
  document: HandoverDisputeCreateDocument,
): ContestHandoverDispute {
  return {
    id: result.handover_dispute_id,
    handoverId: document.handoverId,
    description: document.description,
  };
}
